export const searchResults = "_xE1I";
export const searchResultsFromArchive = "mDPKcc";
export default {searchResults,searchResultsFromArchive};